'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
export const ConsumerContext = createContext(undefined);
/**
 * Provider for event based callbacks in MFE.
 *
 * @param root0 props
 * @param root0.children jsx children
 * @param root0.callbackFn callback functions to be used in the consumer
 * @returns a provider that provides the callback functions to the consumer
 */
export function ConsumerProvider({ children, callbackFn }) {
    const value = useMemo(() => ({ callbackFn }), [callbackFn]);
    return _jsx(ConsumerContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=ConsumerProvider.js.map